import { Button, ButtonProps } from '../../components/button/button.js'
import { ViewBase, ViewBaseProps } from '../base/base.js'
import './not-found.css'

export interface NotFoundProps {
    base: ViewBaseProps
    title: string
    message: string
    homeButton: ButtonProps
}

export const NotFound = (props: NotFoundProps) => (
    <ViewBase {...props.base}>
        <div className="not-found">
            <p className="not-found__code">404</p>
            <h1 className="not-found__title">{props.title}</h1>
            <p className="not-found__message">{props.message}</p>
            <Button {...props.homeButton} />
        </div>
    </ViewBase>
)
